/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Setting_UpInputs */



/**
* | output |
* | --- |
* | "Setting up..." |
*
* @param {Profile_Security_Setting_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_setting_up = /** @type {((inputs?: Profile_Security_Setting_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Setting_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird eingerichtet...")
	return /** @type {LocalizedString} */ ("Setting up...")
});